module.exports = __webpack_public_path__ + "img/LV40003043232.b6c2fa59.png";